import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IAccelerationTaskInfo } from '../../../../ts/models/IAccelerationTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeScheduleActionService } from '../../../../ts/services/ChangeScheduleAction';
import { DeleteDataAccelerationTasksAction } from '../../../../ts/services/dataAcceleration/DeleteDataAccelerationTasksAction';
import { RunDataAccelerationTasksAction } from '../../../../ts/services/dataAcceleration/RunDataAccelerationTasksAction';
import { ChangeDataAccelerationTaskSchedule, DeleteDataAccelerationTask, RunDataAccelerationTaskRunNow } from '../../../actions/AppActionTypes';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DataAccelerationTaskMenuAction } from '../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';

export function* handleRunNow(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(runNow, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function runNow(accelerationTasks: IAccelerationTaskInfo[]) {
  return RunDataAccelerationTasksAction.showRunDataAccelerationDialog(Set.fromIdItemArray(accelerationTasks));
}

export function* handleDeleteDataAccelerationTask(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(executeDeleteDataAccelerationTask, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function executeDeleteDataAccelerationTask(items: IAccelerationTaskInfo[]) {
  return DeleteDataAccelerationTasksAction.executeWithContext(Set.fromIdItemArray(items));
}

export function* handleChangeDataAccelerationTaskSchedule(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(executeChangeDataAccelerationTaskSchedule, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function executeChangeDataAccelerationTaskSchedule(items: IAccelerationTaskInfo[]) {
  return ChangeScheduleActionService.forDataAccelerationTasks(Set.fromIdItemArray(items));
}

export function* rootAccelerationTaskMenuActionSaga(): SagaIterator {
  yield takeEvery(RunDataAccelerationTaskRunNow, handleRunNow);
  yield takeEvery(DeleteDataAccelerationTask, handleDeleteDataAccelerationTask);
  yield takeEvery(ChangeDataAccelerationTaskSchedule, handleChangeDataAccelerationTaskSchedule);
}
